<script>
import IconBan from './icons/Ban';

export default ({ $style }) => (
  <div class={$style.wrapper}>
    <div class={$style.icon}>
      <IconBan />
    </div>

    <div class={$style.title}>
      Доступ запрещен
    </div>
    <div class={$style.description}>
      У вас недостаточно прав
    </div>
  </div>
);
</script>

<style lang="scss" module>
@import '@/theme/include.scss';

.wrapper {
  align-items: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  min-height: 100%;
  padding: 1em;
  text-align: center;
}

.icon {
  color: $color-red;
  font-size: 8em;
  margin: .125em 0 0;
}

.title {
  font-size: 1.5em;
  font-weight: bold;
  margin-bottom: .5em;
}
</style>
